import { createSlice } from '@reduxjs/toolkit';
import { resetAllSlices } from '../../Providers/mainStore.slice';

const initialState = {
  docsFetched: [],
  docsPagination: { page: 1, pageSize: 10 },
};

const fileHistorySlice = createSlice({
  name: 'fileHistory',
  initialState,
  reducers: {
    setFileHistoryState: (state, action) => {
      return { ...state, ...action.payload };
    },
    setDocsFetched: (state, action) => {
      state.docsFetched = action.payload;
    },
    setDocsPagination: (state, action) => {
      state.docsPagination = action.payload;
    },
    resetFileHistoryState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetAllSlices, () => {
      return initialState;
    });
  },
});

export const {
  setFileHistoryState,
  resetFileHistoryState,
  setDocsFetched,
  setDocsPagination,
} = fileHistorySlice.actions;

export default fileHistorySlice.reducer;
